/**
 * PC Remote Library
 * Author: Divya Tiwari
 * Created On: 13-03-2023
 */

import React from 'react';
import '../../shared/LibraryTheme.scss';
import BarChart from '../BarChart/BarChart';
import {
  getConvertedValue, getConvertedValues
} from '../UnitHandling/UnitHandling';
import { ConversionType } from '../UnitHandling/UnitModel';
import { handleNegativeScenario } from '../../shared/shared-utility';
type nullableType = number | null | undefined;
interface IAvoidCarbonEmissionProps {
  carbonBaselineWithoutIBO:number | null;
  carbonConsumptionWithIBO:number | null;
  carbonReduction:number | null;
  screenOption: string;
  pastCRDisplayPercentage: nullableType;
  carbonReductionIncreased: boolean;
  totalDays: string;
}

/**
 *
 * Component to display Carbon Usage Graph
 *
 */

function AvoidedCarbonEmission(props: IAvoidCarbonEmissionProps) {
  let screenOption = props.screenOption.toLowerCase();
  let negativeCarbonReduction = 0;
  let carbonContainer, triangle: string,barClassName='';
  let co2Barpercentage = '100';
  const number100 = 100;
  const measurementUnit = 'metric ton';
  if (props.carbonBaselineWithoutIBO && props.carbonConsumptionWithIBO) {
    if (props.carbonConsumptionWithIBO < props.carbonBaselineWithoutIBO) {
      co2Barpercentage = (
        number100 -
        ((props.carbonBaselineWithoutIBO - props.carbonConsumptionWithIBO) /
          props.carbonBaselineWithoutIBO) *
          number100
      ).toString();
    } else if (
      props.carbonConsumptionWithIBO === props.carbonBaselineWithoutIBO
    ) {
      co2Barpercentage = co2Barpercentage.toString();
    } else {
      co2Barpercentage = co2Barpercentage.toString();
    }
  } else {
    co2Barpercentage = co2Barpercentage.toString();
  }
  //red-green triangle condition
  const checkCarbonReduction = () => {
    if (props.carbonReductionIncreased === true) {
      triangle = 'arrow-down';
    } else {
      triangle = 'arrow-up';
    }
  };

  const checkScreenOption = () => {
    if (screenOption === 'landscape') {
      carbonContainer =
        'avaoid-co2-emission-container lanscape-carbon-container';
        barClassName='barchart-landscape';
    } else {
      carbonContainer =
        'avaoid-co2-emission-container portrait-carbon-container';
        barClassName='barchart-portrait';
    };
  };
  checkCarbonReduction();
  checkScreenOption();

  const getCo2Percentage = () => {
    if(!props.pastCRDisplayPercentage) {
      return '100';
    } else {
      return co2Barpercentage;
    };
  };

  const getCarbonConsumptionWithIbo = () => {
    if(props.carbonConsumptionWithIBO) {
      return props.carbonConsumptionWithIBO;
    } else {
      return negativeCarbonReduction; 
    };
  };

  const getCarbonConsumptionWithoutIbo = () => {
    if(props.carbonBaselineWithoutIBO) {
      return props.carbonBaselineWithoutIBO;
    } else {
      return negativeCarbonReduction; 
    };
  };

  const getPRPercentageUI = () => {
    if(props.pastCRDisplayPercentage) {
      return (
        <div className="flex flex-row align-center">
          <div className={`${triangle}`} />
          <span className="increased-value">
          {props.pastCRDisplayPercentage}% {'  '} from last week
          </span>
        </div>
      );
    } else {
      return (
        <div className="increased-value-equal-gap"></div>
      );
    };
  };
// Unit Conversion
const  carbonConsumptionWithIBO = getConvertedValue(ConversionType.CARBON,measurementUnit,getCarbonConsumptionWithIbo()).Value;
const  carbonConsumptionWithIBOUnit = getConvertedValue(ConversionType.CARBON,measurementUnit,getCarbonConsumptionWithIbo()).Unit;

const  carbonBaselineWithoutIBO = getConvertedValue(ConversionType.CARBON,measurementUnit,getCarbonConsumptionWithoutIbo()).Value;
const  carbonBaselineWithoutIBOUnit = getConvertedValue(ConversionType.CARBON,measurementUnit,getCarbonConsumptionWithoutIbo()).Unit;

const carbonReduction =  getConvertedValue(ConversionType.CARBON,measurementUnit,handleNegativeScenario(props.carbonReduction)).Value;
const carbonReductionUnit =  getConvertedValue(ConversionType.CARBON,measurementUnit,handleNegativeScenario(props.carbonReduction)).Unit;

  return (
    <div className={carbonContainer}>
      <div className="avoided-co2-heading">Avoided Carbon Emissions</div>
      <div className="avoided-co2-data">
        <div className="co2-data-text">
          <span className="highlight-text">
          {getConvertedValues(carbonReduction)} {' '}
            {carbonReductionUnit}*
          </span>
          {getPRPercentageUI()}
        </div>
      </div>
      <div className="co2-status-bar-chart">
        <BarChart
          withIBObgcolor={'#f37021'}
          progress={getCo2Percentage()}
          withOutIBObgcolor={'#fde2d3'}
          barPosition={'start'}
          barClassName={barClassName}
        />
        <div className="co2-bar-chart-summary">
          <div className="co2-with-ibo-container">
            {<div className="co2-with-ibo-heading">
              <div> With</div>  <div>Optimization</div>
              </div>}
            <div className="co2-with-ibo-value">
              <div className="co2-ibo-circle" />
              <div>
              <span className="emaas-summary-value actual-cost">
                      {getConvertedValues(carbonConsumptionWithIBO)} {' '}
                    </span>
                    <span className="emaas-summary-unit">
                      {carbonConsumptionWithIBOUnit}
                    </span>
              </div>
            </div>
          </div>
          <div className="co2-without-ibo-container">
            <div className="co2-without-ibo-heading">
            <div> Without</div>  <div>Optimization</div></div>
            <div className="co2-without-ibo-value">
              <div>
              <span className="emaas-summary-value actual-cost">
                      {getConvertedValues(carbonBaselineWithoutIBO)} {' '}
                    </span>
                    <span className="emaas-summary-unit">
                      {carbonBaselineWithoutIBOUnit}
                    </span>
              </div>
              <div className="co2-without-ibo-circle" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AvoidedCarbonEmission;
